module.exports = __webpack_public_path__ + "assets/img/apple-logo-white.5f27c684.png";